// Componente 100 % estático – sin Firebase.
// Muestra cuántos mensajes se reciben en cada hora del día.

import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import "./Analytics.css";

/* ====== DATOS ESTÁTICOS ======
   Ajusta libremente los conteos; son meramente ilustrativos.
   Cada objeto representa la hora y la cantidad de mensajes.      */
const HOUR_DATA = [
  { hour: "00", count: 12 }, { hour: "01", count: 8  },
  { hour: "02", count: 6  }, { hour: "03", count: 4  },
  { hour: "04", count: 3  }, { hour: "05", count: 2  },
  { hour: "06", count: 5  }, { hour: "07", count: 9  },
  { hour: "08", count: 18 }, { hour: "09", count: 27 },
  { hour: "10", count: 34 }, { hour: "11", count: 30 },
  { hour: "12", count: 22 }, { hour: "13", count: 19 },
  { hour: "14", count: 25 }, { hour: "15", count: 31 },
  { hour: "16", count: 37 }, { hour: "17", count: 40 },
  { hour: "18", count: 33 }, { hour: "19", count: 28 },
  { hour: "20", count: 20 }, { hour: "21", count: 16 },
  { hour: "22", count: 14 }, { hour: "23", count: 11 },
];

// Total de mensajes (por si lo quieres mostrar en algún lado)
const TOTAL = HOUR_DATA.reduce((acc, d) => acc + d.count, 0);

const KEY_METRICS = [
  { label: "Mensajes diarios", value: "1.280", trend: "+12% vs ayer" },
  { label: "Tiempo medio de respuesta", value: "1m 45s", trend: "-18%" },
  { label: "Tasa de resolución", value: "92%", trend: "+4 pts" },
];

const AnalyticsStatic = () => (
  <div className="analytics-page">
    <div className="analytics-hero">
      <div>
        <p className="analytics-badge">Dashboard de insight</p>
        <h1>Analíticas de conversaciones</h1>
        <p className="analytics-hero-text">
          Visualizá el pulso horario de tus chats y preparate para la versión
          completa del panel de métricas.
        </p>
      </div>
      <button className="analytics-pill">Nueva vista próximamente</button>
    </div>

    <div className="analytics-stats-grid">
      {KEY_METRICS.map((metric) => (
        <article key={metric.label} className="analytics-stat-card">
          <span className="stat-label">{metric.label}</span>
          <h3>{metric.value}</h3>
          <p>{metric.trend}</p>
        </article>
      ))}
    </div>

    <section className="analytics-card">
      <header className="analytics-card-header">
        <div>
          <p className="analytics-subtitle">Distribución horaria</p>
          <h2>Mensajes recibidos por hora</h2>
        </div>
        <span className="analytics-chip">UTC-3</span>
      </header>

      <div className="analytics-chart-wrapper">
        <ResponsiveContainer width="100%" height={280}>
          <BarChart data={HOUR_DATA} margin={{ top: 10, right: 20, left: 0, bottom: 10 }}>
            <defs>
              <linearGradient id="violetGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#B06CFF" stopOpacity={1} />
                <stop offset="100%" stopColor="#4C1D71" stopOpacity={1} />
              </linearGradient>
            </defs>
            <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.12} />
            <XAxis dataKey="hour" tick={{ fill: "#C9B9F6", fontSize: 12 }} tickLine={false} axisLine={false} />
            <YAxis tick={{ fill: "#C9B9F6", fontSize: 12 }} tickLine={false} axisLine={{ stroke: "#2F275C" }} />
            <Tooltip
              cursor={{ fill: "rgba(255,255,255,0.04)" }}
              formatter={(v) => [`${v}`, "Mensajes"]}
              labelFormatter={(h) => `${h}:00`}
            />
            <Bar dataKey="count" fill="url(#violetGradient)" radius={[8, 8, 0, 0]} barSize={18} />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </section>

    <footer className="analytics-footer">
      <div>
        <p>Totales analizados en la última ventana:</p>
        <strong>{TOTAL} mensajes</strong>
      </div>
      <button className="analytics-ghost-button">Recibir reporte semanal</button>
    </footer>
  </div>
);

export default AnalyticsStatic;
